module.exports = __webpack_public_path__ + "img/19.5.A.f51cdfd2.png";